import moment from 'moment';

const formatDate = (value) => {
  if (value) {
    return moment(value).format('YYYY-MM-DD');
  }
};
const formatDate1 = (value) => {
  if (value) {
    return moment(value).format('YYYY/MM/DD');
  }
};

const formatDateTime1 = (value) => {
  if (value) {
    return moment(value).format('YYYY/MM/DD HH:mm:ss');
  }
};
const formatDateTime = (value) => {
  if (value) {
    return moment(value).format('YYYY-MM-DD HH:mm:ss');
  }
};

const formatDateTimeMinute = (value) => {
  if (value) {
    return moment(value).format('YYYY-MM-DD HH:mm');
  }
};

const yesNoFilter = (value) => {
  if (value === 1) {
    return '是';
  } else {
    return '否';
  }
};

const filterAddress = (addressList, cityId) => {
  return addressList.filter((address) => address.uaEventCityId === cityId);
};

const filterCoach = (coachList, level) => {
  return coachList.filter((coach) => coach.level === level);
};
export {
  formatDate,
  formatDate1,
  formatDateTime,
  formatDateTime1,
  formatDateTimeMinute,
  yesNoFilter,
  filterAddress,
  filterCoach,
};
